import {CutHandlingMode} from "@/shared/timrTypes";

export interface CutHandlingConfiguration {
	cutHandlingMode: CutHandlingMode;
	cutWarningThresholdDuration: number | null;
}

export function cutHandlingConfigurationsEqual(first: CutHandlingConfiguration, second: CutHandlingConfiguration): boolean {
	return first.cutHandlingMode === second.cutHandlingMode
		&& first.cutWarningThresholdDuration === second.cutWarningThresholdDuration;
}

/** The threshold only applies to DOCUMENT while switched on, so it is null otherwise. */
export function toCutHandlingConfiguration(
	cutHandlingMode: CutHandlingMode,
	thresholdEnabled: boolean,
	cutWarningThresholdDuration: number
): CutHandlingConfiguration {
	const thresholdApplies = cutHandlingMode === CutHandlingMode.DOCUMENT && thresholdEnabled;
	return {cutHandlingMode, cutWarningThresholdDuration: thresholdApplies ? cutWarningThresholdDuration : null};
}
